import { Descriptions } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ReportTypeEnum } from "../../../../constants/constants";
import { EcapReportModel } from "../../../../models/ecap-report.model";
import { DATE_UTIL } from "../../../../utils/dateUtils";
import UTIL from "../../../../utils/utils";

interface Props {
    data: EcapReportModel,
    loading?: boolean;
}

const Information = (props: Props) => {

    const { t } = useTranslation();

    return (
        <div className="rapm-report-details-wrapper">
            <Descriptions layout="vertical" column={4} colon={false} >
                {props.data.risk_type === ReportTypeEnum.Ramp ?
                    <Descriptions.Item label={t("RapmReport.lbReportName")}>FY{props.data.fiscal_year} - Quarter {props.data.quarter}</Descriptions.Item> :
                    <Descriptions.Item label={t("RapmReport.lbReportName")}>FY{props.data.fiscal_year}</Descriptions.Item>
                }

                <Descriptions.Item label={t("RapmReport.lbFiscalYear")}>{props.data.fiscal_year}</Descriptions.Item>

                {
                    !!props.data.quarter && <Descriptions.Item label={t("RapmReport.lbQuarter")}>Quarter {props.data.quarter}</Descriptions.Item>
                }

                <Descriptions.Item label={t("RapmReport.lbReportDate")}>
                    {DATE_UTIL.convertServerToViewFormat(props.data.created_on)}
                </Descriptions.Item>

                <Descriptions.Item label={t("RapmReport.lbDueDate")}>
                    {DATE_UTIL.convertServerToViewFormat(props.data.due_date)}
                </Descriptions.Item>
                <Descriptions.Item label={t("RapmReport.lbReportOwner")}>{props.data.created_by}</Descriptions.Item>
                {/* {
                        props.data.risk_type === EcapReportTypeEnum.BusinessRisk &&
                        <Descriptions.Item label={t("EcapModule.lbTargetRating")}>{props.data.target_rating}</Descriptions.Item>
                    } */}
                <Descriptions.Item label={t("RapmReport.lbStatus")}>{UTIL.getLossStatesDOM(props.data.submit_state).text}</Descriptions.Item>
            </Descriptions>
        </div >
    )
}

export default Information;